import Card from '../../components/Card';
import { CardsContainer } from './styles';

export const createCarouselCards = (data, setOpenModal, open, setModalInformation) => {
  const { productos, cantProductosPorPantalla } = data;

  let items = [];
  let item = [];
  let productosPorPantalla = 0;

  productos.map((producto, i) => {
    if (productosPorPantalla <= cantProductosPorPantalla) {
      item.push(
        <Card
          details={producto.details}
          setModalInformation={setModalInformation}
          open={open}
          setOpenModal={setOpenModal}
          title={producto.title}
          description={producto.description}
          image={producto.image}
        />
      );
      productosPorPantalla++;
    }

    if (productosPorPantalla === cantProductosPorPantalla || productos.length - 1 === i) {
      items.push({
        id: i,
        renderItem: <CardsContainer>{item.map((item) => item)}</CardsContainer>,
      });
      item = [];
      productosPorPantalla = 0;
    }
    return;
  });
  return items;
};
